var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5928 3.04663L6.83505 12.3842L4.08763 13.1624C4.40034 12.5493 4.75773 12.0305 5.15979 11.6061C5.60653 11.1817 6.0756 10.9695 6.56701 10.9695C7.72852 10.9695 8.77835 11.4882 9.71649 12.5257C10.6993 13.5632 11.1907 14.8601 11.1907 16.4164C11.1907 18.067 10.6546 19.5054 9.58247 20.7315C8.51031 21.9105 7.19244 22.5 5.62887 22.5C4.10997 22.5 2.7921 21.9105 1.67526 20.7315C0.558419 19.5525 0 18.1141 0 16.4164C0 15.7562 0.134021 14.978 0.402062 14.082C0.670103 13.1388 1.16151 11.9598 1.87629 10.545L7.03608 0.5L11.5928 3.04663ZM26 3.04663L21.2423 12.3842L18.4948 13.1624C18.8076 12.5493 19.1649 12.0305 19.567 11.6061C19.9691 11.1817 20.4381 10.9695 20.9742 10.9695C22.1357 10.9695 23.1856 11.4882 24.1237 12.5257C25.1065 13.5632 25.5979 14.8601 25.5979 16.4164C25.5979 18.067 25.0395 19.5054 23.9227 20.7315C22.8505 21.9105 21.5326 22.5 19.9691 22.5C18.4948 22.5 17.1993 21.9105 16.0825 20.7315C14.9656 19.5525 14.4072 18.1141 14.4072 16.4164C14.4072 15.7562 14.5412 14.978 14.8093 14.082C15.0773 13.1388 15.5687 11.9598 16.2835 10.545L21.4433 0.5L26 3.04663Z",
    fill: "#E87B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.29f7d371d4df63719725f19ca19aab5d.svg";
export { ForwardRef as ReactComponent };